import {useSelector} from "react-redux";
import {TABLES} from "../../../../../Apis/Tables";
import {VISITOR_SUB_VIEW_MODEL} from "../../Invitation/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 * VisitorRequestMainApp is a controller hook used in the Visitor Request module to manage
 * view transitions, access control, and module configuration.
 *
 * It provides functionality to switch between request views, and exposes user permissions
 * and development mode flags from the Redux store.
 *
 * @function
 * @param {Function} setSubView - State setter to update the current subview.
 * @param {Function} setOption - State setter to define the selected option or table key.
 * @param {Function} setModuleId - State setter to assign the active module ID.
 *
 * @param setSearchElement
 * @param setFinalArray
 * @param setSearch
 */
export const VisitorRequestMainApp =({ setSubView, setOption, setSearchElement, setFinalArray, setSearch })=>{
    const { permission } = useSelector((state) => state.authenticatioauthennSlice); // Getting user permissions from Redux store
    const DEV = useSelector((state) => state?.CommonsSlice?.development); // Checking if the application is in development mode

    /**
     * Handles button clicks to change the subview.
     * @param {'REQUESTED' | 'STATUS'} viewType
     */
    const handleChangeView = (viewType) => {
        setOption(TABLES.VISITOR_REQUEST);
        setSubView(VISITOR_SUB_VIEW_MODEL.REQUESTS[viewType]);
        setSearchElement('');
        setFinalArray([]);
        setSearch(true);
    }

    return {
        setSubView,
        handleChangeView,
        permission,
        DEV
    }
}
